module.exports = __webpack_public_path__ + "img/pickUpTopDefault.3eac6a03.png";